import React, { useState, useEffect } from "react";
import { FiUser, FiHash, FiCheckCircle } from "react-icons/fi";
import InputField from "../../../ResuableCompoment/InputField";
import useApi from "../../../CustomHooks/useApi";
import Popup from "../../../ResuableCompoment/Popup";

const AccountVerificationDetails = ({ data, onUpdate, onBankVerified, onNext }) => {
  const [isVerifying, setIsVerifying] = useState(false);
  const [bankVerified, setBankVerified] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const [formData, setFormData] = useState({
    accountHolderName: data.accountHolderName || "",
    accountNumber: data.accountNumber || "",
    ifscCode: data.ifscCode || "",
    bankName: data.bankName || "",
  });

  const { callApi: bankverify } = useApi(
    "/staff/onboard/verify/bene",
    "POST"
  );

  useEffect(() => {
    setFormData({
      accountHolderName: data.accountHolderName || "",
      accountNumber: data.accountNumber || "",
      ifscCode: data.ifscCode || "",
      bankName: data.bankName || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const updated = { ...formData, [e.target.name]: e.target.value };
    setFormData(updated);
    onUpdate(updated);
    onBankVerified(false);
  };

  const handleVerifyBank = async () => {
    setIsVerifying(true);

    try {
      const payload = {
        beneficiaryAccount: formData.accountNumber,
        beneficiaryIFSC: formData.ifscCode,
        beneficiaryName: formData.accountHolderName,
        nameMatchScore: "1",
        nameFuzzy: true,
      };

      const res = await bankverify(payload);

      if (res === true) {
        setBankVerified(true);
        onBankVerified(true);
        setPopupMessage("Bank account verified successfully.");
      } else {
        setPopupMessage("Bank verification failed. Please check details.");
        onBankVerified(true);
      }

      setShowPopup(true);
    } catch (error) {
      setPopupMessage("Something went wrong during verification.");
      setShowPopup(true);
      onBankVerified(true);
    } finally {
      setIsVerifying(false);
    }
  };

  const isVerifyDisabled =
    !formData.accountHolderName ||
    !formData.accountNumber ||
    !formData.ifscCode ||
    !formData.bankName ||
    isVerifying ||
    bankVerified;

  return (
    <>
      <div className="w-full min-h-[420px]">
        <h3 className="text-lg font-semibold text-[#0A2A4F] mb-6">
          Account Verification
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <InputField
            label="Account Holder Name *"
            name="accountHolderName"
            icon={FiUser}
            value={formData.accountHolderName}
            onChange={handleChange}
            disabled={bankVerified}
          />

          <InputField
            label="Account Number *"
            name="accountNumber"
            icon={FiHash}
            value={formData.accountNumber}
            onChange={handleChange}
            disabled={bankVerified}
            iconRight={
              bankVerified ? (
                <FiCheckCircle className="text-[#0A2A4F]" />
              ) : null
            }
          />

          <InputField
            label="IFSC Code *"
            name="ifscCode"
            icon={FiHash}
            value={formData.ifscCode}
            onChange={handleChange}
            disabled={bankVerified}
          />

          <InputField
            label="Bank Name *"
            name="bankName"
            icon={FiUser}
            value={formData.bankName}
            onChange={handleChange}
            disabled={bankVerified}
          />

          <div className="md:col-span-2 flex gap-4">
            <button
              type="button"
              onClick={handleVerifyBank}
              disabled={isVerifyDisabled}
              className="w-full md:w-1/3 bg-[#0A2A4F] hover:bg-[#08305e] text-white h-[46px] rounded-full disabled:opacity-50"
            >
              {bankVerified ? "Verified" : "Verify Bank"}
            </button>

            {/* <button
              type="button"
              onClick={onNext}
              className="w-full md:w-1/3 border border-[#0A2A4F] text-[#0A2A4F] h-[46px] rounded-full"
            >
              Skip
            </button> */}
          </div>
        </div>
      </div>

      {/* Popup */}
      {showPopup && (
        <Popup
          message={popupMessage}
          onClose={() => setShowPopup(false)}
        />
      )}
    </>
  );
};

export default AccountVerificationDetails;
